import CloseIcon from '@mui/icons-material/Close';
import trioLogo from '@/assets/trioLogo.png';
import * as S from './InstallBanner.styles';

type InstallBannerProps = {
  onInstall: () => void;
  onDismiss: () => void;
};

const InstallBanner = function ({ onInstall, onDismiss }: InstallBannerProps): JSX.Element {
  return (
    <S.Banner>
      <S.IconWrapper>
        <img src={trioLogo} alt="Trio" />
      </S.IconWrapper>
      <S.Content>
        <S.Title>Install Trio</S.Title>
        <S.Subtitle>Add to your home screen for quick access</S.Subtitle>
      </S.Content>
      <S.Actions>
        <S.InstallButton onClick={onInstall}>Install</S.InstallButton>
        <S.DismissButton onClick={onDismiss}>
          <CloseIcon />
        </S.DismissButton>
      </S.Actions>
    </S.Banner>
  );
};

export default InstallBanner;
